import React, { SVGProps } from 'react';

export const LevelIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='shrink-0'
  >
    <path
      d='M20.39 8.56001L19.15 10.42C19.7432 11.6031 20.0336 12.9148 19.9952 14.2377C19.9568 15.5606 19.5908 16.8533 18.93 18H5.07C4.21117 16.5101 3.8553 14.7831 4.05514 13.0751C4.25499 11.367 4.99991 9.76884 6.17948 8.51744C7.35905 7.26604 8.91047 6.42805 10.6037 6.12771C12.297 5.82736 14.042 6.08064 15.58 6.85001L17.44 5.61001C15.4695 4.33293 13.1125 3.78997 10.7819 4.07628C8.45133 4.36259 6.29581 5.45991 4.69306 7.17595C3.0903 8.892 2.14253 11.1173 2.01582 13.462C1.8891 15.8067 2.59152 18.1212 4 20H20C21.2266 18.3613 21.9207 16.3856 21.9887 14.3398C22.0566 12.2939 21.4951 10.2765 20.38 8.56001H20.39Z'
      fill='#333333'
    />
    <path
      d='M10.59 15.41C10.7758 15.596 10.9963 15.7435 11.2391 15.8441C11.4819 15.9448 11.7422 15.9966 12.005 15.9966C12.2678 15.9966 12.5281 15.9448 12.7709 15.8441C13.0137 15.7435 13.2343 15.596 13.42 15.41L19.08 6.92001L10.59 12.58C10.4041 12.7658 10.2565 12.9863 10.1559 13.2291C10.0552 13.4719 10.0034 13.7322 10.0034 13.995C10.0034 14.2578 10.0552 14.5181 10.1559 14.7609C10.2565 15.0037 10.4041 15.2243 10.59 15.41V15.41Z'
      fill='#333333'
    />
  </svg>
);

export const TimelapseIcon = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='shrink-0'
  >
    <path
      d='M16.24 7.76C15.07 6.59 13.54 6 12 6V12L7.76 16.24C10.1 18.58 13.9 18.58 16.24 16.24C18.59 13.9 18.59 10.1 16.24 7.76ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z'
      fill='#333333'
    />
  </svg>
);

export const CheckCircleIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='stroke-accent-700'
  >
    <path
      d='M6 8L7.33333 9.33333L10 6.66667M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const Binoculars = () => (
  <svg
    width='73'
    height='72'
    viewBox='0 0 73 72'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='36.25' cy='36' r='36' fill='white' />
    <g clipPath='url(#clip0_binoculars)'>
      <path
        d='M26.8591 32.5217C26.233 31.2695 23.7287 30.4347 22.5548 30.1738H18.6417L15.12 32.5217L12.7722 36.0434L12.3809 39.1738L12.7722 42.6956L15.12 45.826L19.4243 48.5651H23.3374C24.5113 47.7825 27.1722 45.7477 28.4243 43.8695C29.9896 41.5217 29.2069 40.3477 29.2069 37.6086C29.2069 34.8695 27.6417 34.0869 26.8591 32.5217Z'
        fill='white'
      />
      <path
        d='M21.2441 29.478C16.1415 29.478 11.9902 33.8935 11.9902 39.3197C11.9902 44.746 16.1415 49.1614 21.2441 49.1614C26.3466 49.1614 30.4979 44.746 30.4979 39.3197C30.4979 33.8935 26.3466 29.478 21.2441 29.478ZM21.2441 47.8984C16.8397 47.8984 13.2559 44.0504 13.2559 39.3176C13.2559 34.5849 16.8397 30.7369 21.2441 30.7369C25.6484 30.7369 29.2323 34.587 29.2323 39.3176C29.2323 44.0483 25.6484 47.8984 21.2441 47.8984Z'
        fill='#FB2E4B'
      />
    </g>
    <defs>
      <clipPath id='clip0_binoculars'>
        <rect
          width='54'
          height='32.087'
          fill='white'
          transform='translate(9.25 20)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const Clipboard = () => (
  <svg
    width='72'
    height='72'
    viewBox='0 0 72 72'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='36' cy='36' r='36' fill='white' />
    <g clipPath='url(#clip0_clipboard)'>
      <path
        d='M49.5 15.5L20 16L17.5 16.5L16.5 19V52L17 58L19.5 59.5H51.5L54.5 58.5L55 55V19L53.5 16L49.5 15.5Z'
        fill='white'
      />
      <path
        d='M39.5 12L37.5 10L35.5 9.5L33.5 10L32.5 12L31.5 14L28.5 15.5L26.5 17.5V19H45L45.5 18.5L43.5 16L40 14L39.5 12Z'
        fill='#FDABB7'
      />
      <path
        d='M51.27 60.3H20.5C18.02 60.3 16 58.28 16 55.8V19.27C16 16.79 18.02 14.77 20.5 14.77H28.72C29.01 14.77 29.26 14.96 29.34 15.23C29.42 15.5 29.32 15.8 29.08 15.96C27.94 16.72 27.21 17.65 26.99 18.62H44.77C44.55 17.65 43.82 16.73 42.68 15.96C42.44 15.8 42.34 15.5 42.42 15.23C42.5 14.96 42.76 14.77 43.04 14.77H51.26C53.74 14.77 55.76 16.79 55.76 19.27V55.8C55.76 58.28 53.74 60.3 51.26 60.3H51.27Z'
        fill='#FB2E4B'
      />
    </g>
    <defs>
      <clipPath id='clip0_clipboard'>
        <rect
          width='39.76'
          height='51.3'
          fill='white'
          transform='translate(16 9)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const PointingFinger = () => (
  <svg
    width='73'
    height='72'
    viewBox='0 0 73 72'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='36.75' cy='36' r='36' fill='white' />
    <g clipPath='url(#clip0_pointing)'>
      <circle cx='29.75' cy='25' r='12' fill='#FDABB7' />
      <path
        d='M28.2002 28.0402L25.2402 25.0802L25.2602 25.0702L28.2002 28.0102L34.2402 21.9702L34.2602 21.9802L28.2002 28.0402Z'
        stroke='#FB2E4B'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M50.75 43.76V41.93C50.75 40.55 49.63 39.43 48.25 39.43C46.87 39.43 45.75 40.55 45.75 41.93V40.85C45.75 39.47 44.63 38.35 43.25 38.35C41.87 38.35 40.75 39.47 40.75 40.85V29.5C40.75 28.12 39.63 27 38.25 27C36.87 27 35.75 28.12 35.75 29.5V46.05C32.21 40.95 29.04 40.74 27.1 41.78C25.74 42.51 25.75 44.18 25.75 44.18C25.75 44.18 29.37 47.39 31.58 50.95C33.01 53.25 34.37 54.98 36.18 56.79C37.99 58.6 40.23 60.34 43.88 60.34C50.76 60.34 55.76 55.24 55.76 49.72V42.85C55.76 41.47 54.64 40.35 53.26 40.35C51.88 40.35 50.76 41.47 50.76 42.85V43.76H50.75Z'
        fill='white'
        stroke='#FB2E4B'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_pointing'>
        <rect
          width='40'
          height='49.33'
          fill='white'
          transform='translate(16.75 12)'
        />
      </clipPath>
    </defs>
  </svg>
);

type InfoIconProps = {
  fill?: string;
  width?: string | number;
  height?: string | number;
};

export const InfoIcon: React.FC<InfoIconProps> = ({
  fill = '#000000',
  width = '24',
  height = '25',
}) => {
  return (
    <svg
      id='Info_24'
      width={width}
      height={height}
      viewBox='0 0 24 25'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11 7.5H13V9.5H11V7.5ZM11 11.5H13V17.5H11V11.5ZM12 2.5C6.48 2.5 2 6.98 2 12.5C2 18.02 6.48 22.5 12 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 12 2.5ZM12 20.5C7.59 20.5 4 16.91 4 12.5C4 8.09 7.59 4.5 12 4.5C16.41 4.5 20 8.09 20 12.5C20 16.91 16.41 20.5 12 20.5Z'
        fill={fill}
      />
    </svg>
  );
};

interface SimpleCheckIconProps {
  fill?: string;
  width?: number;
  height?: number;
  className?: string;
}

export const SimpleCheckIcon: React.FC<SimpleCheckIconProps> = ({
  width = 18,
  height = 18,
  fill = '#0D7D4D',
  className,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Check Icon</title>
    <path
      d='M6.75005 12.15L3.60005 8.99995L2.55005 10.05L6.75005 14.25L15.75 5.24995L14.7 4.19995L6.75005 12.15Z'
      fill={fill}
    />
  </svg>
);

export const Ruler = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 298 51'
    width='100%'
    height={51}
    preserveAspectRatio='none'
    fill='none'
    {...props}
  >
    <g stroke='#B7C5D9' strokeLinecap='round' strokeWidth={2} opacity={0.5}>
      <path d='M1 51.075V28.819M18 51.075V12.128M34 51.075V28.819M51 51.075V1M51 51.075V1M67 51.075V28.819M83 51.075V12.128M100 51.075V28.819M116 51.075V1M116 51.075V1M133 51.075V28.819M149 51.075V12.128M165 51.075V28.819M182 51.075V1M182 51.075V1M198 51.075V28.819M215 51.075V12.128M231 51.075V28.819M247 51.075V1M247 51.075V1M264 51.075V28.819M280 51.075V12.128M297 51.075V28.819' />
    </g>
  </svg>
);

// Arrow Left Icon using lucide-style
export const ArrowLeftIcon = ({
  className,
  size = 24,
}: {
  className?: string;
  size?: number;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
  >
    <path d='M19 12H5M12 19l-7-7 7-7' />
  </svg>
);

// Chevron icons
export const ChevronDown = ({
  className,
  size = 24,
}: {
  className?: string;
  size?: number;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
  >
    <path d='m6 9 6 6 6-6' />
  </svg>
);

export const ChevronUp = ({
  className,
  size = 24,
}: {
  className?: string;
  size?: number;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
  >
    <path d='m18 15-6-6-6 6' />
  </svg>
);

export const ChevronRight = ({
  className,
  size = 24,
}: {
  className?: string;
  size?: number;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
  >
    <path d='m9 18 6-6-6-6' />
  </svg>
);

export const ChevronLeft = ({
  className,
  size = 24,
}: {
  className?: string;
  size?: number;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
  >
    <path d='m15 18-6-6 6-6' />
  </svg>
);

// Close/X Icon
export const CloseIcon = ({
  className,
  size = 24,
}: {
  className?: string;
  size?: number;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
  >
    <path d='M18 6 6 18M6 6l12 12' />
  </svg>
);

// Lock Icon
export const LockIcon = ({
  className,
  size = 24,
}: {
  className?: string;
  size?: number;
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
  >
    <rect width='18' height='11' x='3' y='11' rx='2' ry='2' />
    <path d='M7 11V7a5 5 0 0 1 10 0v4' />
  </svg>
);
